const blogFiles = require.context(
    '../../content/blogs',
    false,
    /\.json$/
);

export const CMSBlogs = blogFiles
    .keys()
    .map((fileName) => {
        const moduleData = blogFiles(fileName);
        const data = moduleData.default || moduleData;

        if (!data || !data.title || !data.slug) {
            return null;
        }

        return {
            ...data,
            id: data.id || `cms-${data.slug}`,
            newPage: `/blogPage/${data.slug}`,
        };
    })
    .filter(Boolean);

export const PublishedCMSBlogs = CMSBlogs.filter((blog) => {
    if (!blog.scheduled) {
        return true;
    }

    if (!blog.publishAt) {
        return false;
    }

    return new Date(blog.publishAt).getTime() <= Date.now();
});


// const blogFiles = require.context(
//     '../../content/blogs',
//     false,
//     /\.json$/
// );

// export const CMSBlogs = blogFiles
//     .keys()
//     .map((fileName) => {
//         const data = blogFiles(fileName);

//         if (!data || !data.title || !data.slug) {
//             return null;
//         }

//         return {
//             ...data,
//             id: data.id || `cms-${data.slug}`,
//             newPage: data.newPage || `/blogPage/${data.slug}`,
//         };
//     })
//     .filter(Boolean);